<template>
  <div>
    <Card>
      <!-- <a-form layout="inline">
        <a-form-item style="margin-bottom: 20px">
          <a-input v-model="dataForm.role_name" placeholder="角色名称">
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button @click="getDataList" type="primary"> 搜索 </a-button>
        </a-form-item>
      </a-form> -->
      <a-table
        :columns="columns"
        :data-source="dataList"
        :pagination="false"
        :loading="dataListLoading"
      >
        <span slot="action" slot-scope="text, record">
          <a-space>
            <a-button
              size="small"
              type="link"
              @click="addOrUpdateHandle(record.id)"
              >编辑数据
            </a-button>
          </a-space>
        </span>
        <!-- <span slot="project_name" slot-scope="text">
          <a-tag color="green">
            {{ text }}
          </a-tag>
        </span> -->
      </a-table>
      <a-pagination
        style="margin-top: 20px; float: right"
        show-size-changer
        :current="page"
        show-quick-jumper
        :total="total"
        @showSizeChange="showSizeChange"
        @change="pageCurrentChangeHandle"
        :show-total="(total) => `共 ${total} 条`"
      />
    </Card>
    <addOrUpdate ref="addOrUpdate" @ok="getDataList"></addOrUpdate>
  </div>
</template>

<script>
import addOrUpdate from "./components/configaddorupdate.vue";
import viewModule from "@/mixins/view-module";
export default {
  components: { addOrUpdate },
  mixins: [viewModule],
  data() {
    return {
      columns: [
        {
          title: "名称",
          align: "center",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "备注",
          align: "center",
          dataIndex: "remark",
          key: "remark",
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      mixinViewModuleOptions: {
        getDataListURL: "/config/page",
      },
      dataForm: { role_name: "" },
    };
  },
  methods: {},
};
</script>

<style></style>